import { apiClient } from './client';
import type { DocumentFolder, CreateDocumentFolderInput } from '@peles/shared';

export async function listDocumentFolders(
  params: { parentId?: string | null; entityType?: string; entityId?: string } = {},
): Promise<DocumentFolder[]> {
  const query = new URLSearchParams();
  if (params.parentId === null) query.set('parentId', 'null');
  else if (params.parentId) query.set('parentId', params.parentId);
  if (params.entityType) query.set('entityType', params.entityType);
  if (params.entityId) query.set('entityId', params.entityId);
  const { data } = await apiClient.get<DocumentFolder[]>(`/document-folders?${query}`);
  return data;
}

export async function getDocumentFolder(id: string): Promise<DocumentFolder> {
  const { data } = await apiClient.get<DocumentFolder>(`/document-folders/${id}`);
  return data;
}

export async function getFolderBreadcrumb(
  id: string,
): Promise<Array<{ id: string; name: string }>> {
  const { data } = await apiClient.get<Array<{ id: string; name: string }>>(
    `/document-folders/${id}/breadcrumb`,
  );
  return data;
}

export async function createDocumentFolder(
  input: CreateDocumentFolderInput,
): Promise<DocumentFolder> {
  const { data } = await apiClient.post<DocumentFolder>('/document-folders', input);
  return data;
}

export async function updateDocumentFolder(id: string, name: string): Promise<DocumentFolder> {
  const { data } = await apiClient.put<DocumentFolder>(`/document-folders/${id}`, { name });
  return data;
}

export async function deleteDocumentFolder(id: string): Promise<void> {
  await apiClient.delete(`/document-folders/${id}`);
}

export async function ensureEntityFolder(
  entityType: string,
  entityId: string,
  entityName: string,
): Promise<DocumentFolder> {
  const { data } = await apiClient.post<DocumentFolder>('/document-folders/ensure-entity', {
    entityType,
    entityId,
    entityName,
  });
  return data;
}
